require('./bootstrap')

/**
 * Packages
 */
require('webpack-jquery-ui/interactions')
require('webpack-jquery-ui/widgets')
require('webpack-jquery-ui/effects')
require('webpack-jquery-ui/autocomplete')
require('webpack-jquery-ui/tooltip');
require('webpack-jquery-ui/css')
require('bxslider/dist/jquery.bxslider.min')
require('jquery.cookie')
require('readmore-js')

import Typed from 'typed.js'
import Polyglot from 'node-polyglot'
import { flare } from "@flareapp/flare-client"
import Alpine from 'alpinejs'
// Flare
if (process.env.NODE_ENV === 'production') {
    flare.light('yQsGOUAqCj8CMbgP76ifB1kBfbqdc9YP');
}

// Localization
window.polyglot = new Polyglot();
var locale_file = require('../../lang/' + AppLang + '.json');
polyglot.extend(locale_file);

window.select2 = require('select2')
window.toastr = require('toastr/toastr')
window.autosize = require('autosize/dist/autosize')

window.Alpine = Alpine
window.Typed = require('typed.js');

Alpine.start()
/**
 * Logout
 */
$(document).ready(function() {
    $('a#LogoutLink').click(function(e) {
        e.preventDefault();
        $('form#LogoutForm').submit();
    })
});
